export const disasters =
  [
    '끼임·감김',
    '떨어짐',
    '넘어짐',
    '베임',
    '부딪힘',
    '이상온도 접촉(화상)',
    '무너짐·깔림',
    '맞음',
    '산소결핍',
    '감전',
    '화재·폭발',
    '기타',
  ]
//   [
//   '(산소)결핍',
//   '가뭄',
//   '간질환',
//   '감염',
//   '감염성 질병',
//   '감전',
//   '교통사고',
//   '그 밖에 근로자의 질병과 업무와의 상당인과관계(相當因果關係)가 인정되는 질병',
//   '근골격계 질병',
//   '기타 근골격계질환',
//   '금속류',
//   '급성 중독 등 화학적 요인에 의한 질병',
//   '깔림',
//   '끼임',
//   '낙하',
//   '난청',
//   '넘어짐',
//   '뇌혈관질환',
//   '심혈관질환',
//   '눈 또는 귀 질병',
//   '동물상해',
//   '독성감염',
//   '뒤집힘',
//   '떨어짐',
//   '림프조혈기계 질병',
//   '맞음',
//   '무너짐',
//   '물리적 요인에 의한 질병',
//   '물리적인자',
//   '베임',
//   '부딪힘',
//   '불균형 및 무리한 동작',
//   '분진',
//   '붕괴',
//   '빠짐',
//   '생물학적인자',
//   '소음노출',
//   '수증관증후군',
//   '신경정신계 질병',
//   '스트레스성질환',
//   '아차사고',
//   '요통',
//   '유기화합물',
//   '유해광선 노출',
//   '이상기압 노출, 접촉',
//   '익사',
//   '절단',
//   '중독',
//   '지진',
//   '직업성 암',
//   '직업병 기타',
//   '직업관련성질병 기타',
//   '진폐',
//   '질식',
//   '질환',
//   '찔림',
//   '체육행사 등의 사고',
//   '충돌',
//   '탈락',
//   '태풍',
//   '파열',
//   '폭력행위',
//   '폭발',
//   '폭설',
//   '폭풍',
//   '피부 질병',
//   '허가대상',
//   '해일',
//   '호우',
//   '호흡기계 질병',
//   '홍수',
//   '화생방사고',
//   '화재',
//   '화학물질 누출 접촉',
//   '화학적인자 기타',
//   '환경오염사고 등',
//   '기타',
//   '분류불능',
//   '직접입력'
// ]
export const valueDisasters = () => {
  return disasters.map((disaster) => {
    return { value: disaster }
  })
}

export const valueDisastersFilters = () => {
  return disasters
    .filter((disaster) => disaster !== '직접입력')
    .map((disaster) => {
      return { value: disaster }
    })
}
